//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const columnRadio = ref('radio-1')
    const rowRadio = ref(null)

    return { columnRadio, rowRadio }
  },
}
